<template>
  <g id="CircleCheck">
    <path
      class="stroke-none"
      d="M11.3,0A11.3,11.3,0,1,0,22.5,11.3,11.2,11.2,0,0,0,11.3,0Zm6.5,6.5L10,16.5c-.1.1-.3.2-.4.4a1.9,1.9,0,0,1-1,.3,1.8,1.8,0,0,1-1.5-.8L4.6,12.9a.8.8,0,0,1,.2-1,.8.8,0,0,1,1.1.1l2.4,3.5a.2.2,0,0,0,.4.1h.1l7.9-9.9a.7.7,0,1,1,1.1.9Z"
    />
  </g>
</template>

<script>
export default {
  name: "IconCheckCircle",
  data() {
    return {};
  },
  props: {
    settings: {
      type: Object
    }
  },
  computed: {
    activeProp: function() {
      if (this.settings.active) {
        return this.settings.active;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
</style>